import { NgModule } from '@angular/core';
import { IconComponent } from './icon.component';

@NgModule({
  imports: [IconComponent],
  declarations: [],
  exports: [IconComponent],
})
export class VaIconModule {}
